<template>
  <static-fullscreen-card @sendHeight="setContentHeight" @sendClass="blockName = $event" :typeShow="typeShow">
    <template v-slot:title>({{ data.id }}) Счет на оплату [{{ statusCurrent.text }}] </template>
    <template v-slot:actions>
      <a-btn-delete v-if="!loading && !showOnly && id && data.status === 1 && getAccess('documents.invoice.delete')" @click="removeDialogShow = true" />
      <a-btn-status v-if="canStatus" :items="m.statuses" @click="clickStatus($event)" :disabled="!canStatus || loading" :data="data" :status="data.status" />
      <v-btn v-if="[1, 3].includes(data.type) || true" @click="preview()" color="primary" class="ml-1">
        <v-icon>fas fa-eye</v-icon>
      </v-btn>
      <v-btn color="primary" @click="showEditDialog = true" title="Редактировать элемент"> <btn-title icon="far fa-edit">Редактировать</btn-title></v-btn>
    </template>
    <portal to="v-main">
      <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" :title="removeTitle" />
      <s-edit-form
        v-model="showEditDialog"
        v-if="showEditDialog"
        :m="m"
        :configForm="{ head: configHead, title: configHead.title, api: url }"
        :id="id"
        :opt="data.status === 0 ? {} : { readonly: true }"
      />
      <s-editor-editor
        v-if="getAccess('suData')"
        ref="suEdit"
        v-model="suEditShow"
        :config="{ table: 'invoice', filter: { id } }"
        @show="suEditShow = true"
        :activate="(id || 0) > 0"
      />
      <s-quick-addDocument v-if="showAddDocDialog" v-model="showAddDocDialog" :id="id" :api="url" :modelDoc="addDocModel" />
      <confirm-dialog ref="confirmDialog" />
    </portal>
    <portal to="v-goup" v-if="idShow && !isInDialog">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <v-row>
      <v-col cols="12" sm="6">
        <material-card>
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelLeft" :config="{ dense: true, hideNull: !true }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6">
        <material-card>
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true, hideNull: !true }" />
        </material-card>
      </v-col>
      <v-col cols="12">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(tab, i) in tabs" v-if="tab.show" :key="i" class="mr-3" :href="`#tab-${tab.name}`"> {{ tab.title }} </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" :style="`min-height: ${detailHeight}px`" touchless>
            <v-tab-item v-for="(t, i) in tabs" :key="i" v-if="t.show" :id="`tab-${t.name}`">
              <s-tabs-cash
                v-if="t.name === 'cash' && mCash"
                :initData="cashInitData"
                :data="parentData"
                :operations="operations"
                type="in"
                :canAdd="data.status == 1 && getAccess('documents.cashIn.create')"
                :m="mCash"
                :height="detailHeight"
              />

              <comment-view v-if="t.name == 'comments'" :height="detailHeight" :id="id || 0" :targetName="'invoice'" :needUpdate="needUpdateComments" />
              <s-tabs-status-history v-if="t.name == 'statusHistory'" :data="data.status_history" :m="m" :height="detailHeight" />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
  </static-fullscreen-card>
</template>

<script>
import { autoHeightBlock, getAccess, popupMenu, removeEl, genModel, statusDoc, comments } from "@/components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, popupMenu, removeEl, genModel, statusDoc, comments],
  components: {},
  props: {
    idShow: Number,
    showOnly: { type: Boolean, default: false },
    typeShow: { type: String, default: "full" },
  },
  data() {
    return {
      id: 0,
      loading: true,
      removeDialogShow: false,
      showEditField: false,
      showEditDialog: false,
      addDocModel: null,
      showAddDocDialog: false,
      suEditShow: false,
      editField: null,
      title: "",
      m: this.$store.getters["config/get"].models.invoice,
      // m: this.$parent.m,
      removeTitle: "Вы действительно хотите удалить эту счет на оплату?",
      data: {},
      parentData: {},
      tab: 0,
      tabs: [
        { name: "cash", title: "Оплата", show: true },
        { name: "statusHistory", title: "История статусов", show: this.getAccess("documents.invoice.statusHistory") },
        { name: "comments", title: "Комментарии", show: this.getAccess("documents.invoice.comments") },
      ],
    };
  },

  created() {
    if (!this.isDialog) this.$root.title = this.m?.title;

    this.id = this.idShow || Number(this.$route.params.id);
    this.fitchData();
  },
  computed: {
    isDialog() {
      return this.typeShow == "dialog";
    },
    cashInitData() {
      let res = {};
      //если пополнение карты или выдача в подотчет
      res["parent_name"] = this.m.accDocName;
      res["parent_id"] = this.id;
      res["object_id"] = this.data?.data?.contract?.object_id;
      res["client_id"] = this.data?.data?.client_id;
      res["_ignoreDocument"] = true;

      console.log("cashInitData", res, this.m);
      return res;
    },
    operations() {
      let res = this.m?.operations || [];
      return res;
    },

    mCash() {
      //если пополнение карты или выдача в подотчет
      //if ([2, 4].includes(this.data.payment_type)) return this.m;
      if (this.data.parent_name === "AccountingDirContract") return this.$store.getters["config/get"].models.invoice;
      return null;
    },
    canStatus() {
      return this.getAccess("documents.invoice.status");
    },
    configHead() {
      let config = JSON.parse(JSON.stringify(this.m?.config.default || {}));
      if (!this.canStatus) config.fieldsRO += (config.fieldsRO ? "," : "") + "date_start";
      return config || {};
    },
    url() {
      let api = this.m.api;
      ////if (this.getAccess("invoice.viewAll")) api = api + "_admin";
      return api;
    },
    api() {
      let api = this.m.api;
      //if (this.getAccess("documents.invoice.viewAll")) api = api + "_admin";
      return api;
    },
    modelLeft() {
      let model = this.calcModel("viewForm1");
      return model;
    },
    modelRight() {
      let model = this.calcModel("viewForm2");
      return model;
    },
    model: {
      get() {
        let model = this.calcModelConfig(this.configHead);
        return model;
      },
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
    showAddDocDialog(v) {
      if (!v) {
        this.fitchData();
      }
    },
  },
  methods: {
    preview() {
      let url = this.$root.config.siteUrl + `/invoice/${this.data.doc_token}.html`;
      //let url = this.$root.config.siteUrl + `/catalog/${this.type}/${this.model.id.toString().md5()}.html`;
      return window.open(url, "_blank");
    },

    afterRemove(data) {
      if (this.idShow || this.typeShow == "dialog") {
        this.$emit("close", this.data);
        return;
      }

      this.removeDialogShow = false;
      this.$router.push({ name: "invoice" });
    },
    async fitchData() {
      //await this.$axios.get("/accounting/doc/invoice/token/4590b2a958eff4c058ec8f2e8905ce3e");
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.afterFetch();
    },
    async afterFetch() {
      let api = this.mCash.api;

      this.parentData = Object.assign({}, this.data);

      this.loading = false;
    },
    showDocs(field) {
      return this.model.find(el => el.name == field)?.category || -1;
    },
    addNewDocs(field) {
      this.addDocModel = this.model.find(el => el.name == field) || null;
      if (!this.addDocModel) return;
      this.showAddDocDialog = true;
    },
  },
};
</script>
